import { render, staticRenderFns } from "./Regulator.vue?vue&type=template&id=1d8e713e&scoped=true&"
import script from "./Regulator.vue?vue&type=script&lang=js&"
export * from "./Regulator.vue?vue&type=script&lang=js&"
import style0 from "./Regulator.vue?vue&type=style&index=0&id=1d8e713e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e713e",
  null
  
)

export default component.exports